module.exports = __webpack_public_path__ + "static/media/activeColour.d50e8b89.svg";